import React from "react";

export default function ProjectCard({ project }) {
  return (
    <div className="card h-100 shadow-sm">
      <img src={project.image} className="card-img-top" alt={project.title} />
      <div className="card-body">
        <h5 className="card-title">{project.title}</h5>
        <p className="card-text">{project.description}</p>
        <a
          href={project.demo}
          className="btn btn-info me-2"
          target="_blank"
          rel="noreferrer"
        >
          Live Demo
        </a>
        <a
          href={project.github}
          className="btn btn-dark"
          target="_blank"
          rel="noreferrer"
        >
          GitHub
        </a>
      </div>
    </div>
  );
}
